// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.selector {\n\tmin-width: 200px;\n}\n.size-small.selector input.form-control,\n.size-small.v-select.single .selected-tag,\n.size-small .selector input.form-control,\n.size-small .v-select.single .selected-tag {\n\tfont-size: 12px;\n}\n.white-bg .selector,\n.white-bg.selector {\n\tbackground: white;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
